<template>
    <form
        id="order_returns_form"
        class="b-return-form__order "
        action="/warehouse/return"
        method="POST"
        v-on:submit.prevent
    >
        <input type="hidden" name="_token" v-model="csrf">
        <div class="form-group">
            <label v-text="trans('order_number_or_tracks_separated')"></label>
            <input type="text"
                   name="order_numbers"
                   class="form-control"
                   v-model="orderNumbers"
                   autocomplete="off"
                   autofocus
                   @keyup.enter="handler"
            >
        </div>
        <div v-for="(order, index) in orders" v-show="showTable" class="panel panel-default">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-md-12">
                        <span class="b-return-form__order__number">
                            <span :class="'b-admin-domain__label ' + order.domain.template" v-text="order.domain.short_title"></span>
                            <b v-text="`${trans('order_number')}: ${order.order_number}`"></b>
                            <span v-text="`${trans('track')}: ${order.track}`"></span>
                        </span>
                        <span class="status" :class="order.status.code">{{ order.status.title }}</span>
                        <div class="pull-right" @click="removeOrderFromList(index)" style="cursor: pointer">
                            <i class="fa fa-close text-red"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <table class="table table-striped ">
                    <tbody>
                    <tr>
                        <td class="col-md-12">
                            <table class="table table-striped b-return-form__order__items">
                                <thead>
                                <tr>
                                    <th class="col-md-3" v-text="trans('title')"></th>
                                    <th class="col-md-3" v-text="trans('brand')"></th>
                                    <th class="col-md-3" v-text="trans('pack')"></th>
                                    <th class="col-md-3" v-text="trans('quantity')"></th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="order_item in order.order_items">
                                        <input
                                                type="hidden"
                                                :name="`variants[${order.domain_id}][${order.order_number}][average_purchase_price][${order_item.variant.id}]`"
                                                :value="order_item.average_purchase_price"
                                        >
                                        <td class="col-md-3">{{ order_item.variant.product.name ? order_item.variant.product.name : order_item.product.name }}</td>
                                        <td class="col-md-3">{{ order_item.variant.product.brand.title }}</td>
                                        <td class="col-md-3">{{ order_item.variant.title }}</td>
                                        <td class="col-md-3">
                                            <span>{{ order_item.variant.count }}</span>
                                            <input
                                                    type="number"
                                                    class="form-control input-sm"
                                                    :name="`variants[${order.domain_id}][${order.order_number}][mutated][${order_item.variant.id}]`"
                                                    v-model="order_item.quantity"
                                            >
                                            <input
                                                    type="hidden"
                                                    :name="`variants[${order.domain_id}][${order.order_number}][original][${order_item.variant.id}]`"
                                                    :value="order_item.original_quantity"
                                            >
                                        </td>
                                    </tr>
                                    <tr v-for="(appended_item, index) in appended"
                                        v-if="appended_item.order_number == `${order.domain_id}_${order.order_number}`"
                                    >
                                        <td class="col-md-3">
                                            <div class="btn btn-danger btn-xs" title="удалить" @click="removeAppendedProduct(index)">
                                                <i class="fa fa-times" aria-hidden="true"></i>
                                            </div>
                                            {{ appended_item.product.name }}
                                        </td>
                                        <td class="col-md-3">{{ appended_item.product.brand.title }}</td>
                                        <td class="col-md-3">{{ appended_item.title }}</td>
                                        <td class="col-md-3">
                                            <input
                                                    type="number"
                                                    class="form-control input-sm"
                                                    :name="`variants[${order.domain_id}][${order.order_number}][mutated][${appended_item.id}]`"
                                                    v-model="appended_item.self_count"
                                            >
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <br>
                <button v-show="showTable" type="button" class="btn btn-primary btn-xs b-return-form__add-variant"
                     @click="setOrderNumber(order.order_number, order.domain_id)" data-toggle="modal" data-target="#productsModal"
                >
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    <span v-text="trans('select_products_button')"></span>
                </button>
            </div>
        </div>
        <div>
            <input @click="submit()"
                   v-show="orders.length"
                   class="btn btn-primary"
                   :value="trans('save_button', null)"
            >
        </div>
    </form>
</template>

<script>
import * as Functions from '../Functions';

export default {
    props: ['translations'],
    mounted: function() {
        let token = document.querySelector('#token').getAttribute('content');
        Vue.http.headers.common['X-CSRF-TOKEN'] = token;
        this.csrf = token;
        this.listenProductItemSelect();
    },
    data: function () {
        return {
            orderNumbers: [],
            orders: {},
            appended: [],
            currentOrderNumber: '',
            showTable: false,
            csrf: ''
        };
    },
    methods: {
        trans(name, path = 'stock') {
            return Functions.trans(this.translations, name, path);
        },
        download: function () {
            this.showTable = false;

            this.$http.post('/warehouse/return/get_orders', {
                order_numbers: this.orderNumbers})
                .then(function (response) {
                    this.orders = this.getPreparedOrders(response.data.orders);
                    this.showTable = true;
                }, function (response) {
                    console.log(response);
            });
        },
        getPreparedOrders: function (orders) {
            for (let i = 0; i < orders.length; i++) {
                for (let k = 0; k < orders[i]['order_items'].length; k++) {
                    orders[i]['order_items'][k].original_quantity = orders[i]['order_items'][k].quantity;
                }
            }

            return orders;
        },
        handler: function(event) {
            this.orderNumbers = this.orderNumbers + " ";
            event.preventDefault();
            this.download();
        },
        submit: function() {
            let self = this;

            let statuses = [];
            this.orders.forEach(function (order) {
                if (self.orderIsEmpty(order) && confirm('Поставить заказу #' + order.order_number + ' статус "Украден" вместо "Возврат"?')) {
                    statuses.push(order.id);
                }
            });

            let form = document.querySelector('#order_returns_form');
            let el = document.createElement("input");
            el.type = "hidden";
            el.name = "stolen_orders";
            el.value = JSON.stringify(statuses);
            form.appendChild(el);
            form.submit();
        },
        orderIsEmpty: function (order) {
            let isEmpty = true;
            order.order_items.forEach(function (order_item) {
                if (order_item.quantity > 0) {
                    isEmpty = false;
                }
            });

            if (isEmpty) {
                this.appended.forEach(function (variant) {
                    let number = variant.order_number.split('_')[1];
                    if (number == order.order_number && variant.self_count > 0) {
                        isEmpty = false;
                    }
                });
            }

            return isEmpty;
        },
        listenProductItemSelect: function () {
            let self = this;
            $(document).on('click', '#apply_order_products_popup_vue', function() {
                self.displaySelectedVariant(self.currentOrderNumber);
            });
        },
        displaySelectedVariant: function (order_number) {
            let selectedVariants = this.getSelectedVariants();
            let self = this;

            if (selectedVariants.length) {
                this.$http.post('/warehouse/return/get_variants', {
                    variant_ids: selectedVariants
                })
                    .then(function (response) {
                        let variants = response.data.variants;
                        let newAppended = self.appended;
                        for (let i = 0; i < variants.length; i++) {
                            variants[i].order_number = order_number;
                            variants[i].self_count = 1;
                            newAppended.push(variants[i]);
                        }

                        self.appended = newAppended;
                    }, function (response) {
                        console.log(response);
                    });
            }
        },
        getSelectedVariants: function () {
            let selectedIds = [];
            let checkboxes = document.getElementsByClassName('variant-checkbox__selected');

            if (checkboxes.length) {
                for (let i = 0; i < checkboxes.length; i) {
                    selectedIds.push(checkboxes[i].value);
                    checkboxes[i].checked = false;
                    checkboxes[i].classList.remove('variant-checkbox__selected');
                }
            }

            return selectedIds;
        },
        setOrderNumber: function (order_number, domain_id) {
            this.currentOrderNumber = `${domain_id}_${order_number}`;
        },
        removeAppendedProduct: function(index) {
            this.appended.splice(index, 1);
        },
        removeOrderFromList: function (index) {
            this.orders.splice(index, 1);
        },
    }
};
</script>
